import { Component } from '@angular/core';
@Component({
    selector: 'app-klarna-placement-wrapper',
    templateUrl: './klarna-placement-wrapper.component.html'
})
export class KlarnaPlacementWrapperComponent {
}
